
import Vue from 'vue';
import Component from 'vue-class-component';
import { PropSync } from 'vue-property-decorator';

@Component
export default class extends Vue {
  @PropSync('addMember') addMemberSync: string;
}
